var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoomDoubleDelux(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7312 3.35623C11.3037 1.54793 13.6963 1.54792 14.2688 3.35623L15.79 8.16083H20.6291C22.4565 8.16083 23.1962 10.6768 21.6974 11.7943L17.8489 14.6637L19.3342 19.3548C19.912 21.1797 17.9754 22.7342 16.4972 21.6321L12.5 18.6518L8.50285 21.6321C7.02465 22.7342 5.08798 21.1797 5.66576 19.3548L7.15106 14.6637L3.30262 11.7943C1.80379 10.6768 2.54353 8.16083 4.3709 8.16083H9.20997L10.7312 3.35623ZM14.0212 8.80079L12.5 3.99619L10.9788 8.80079C10.7221 9.61146 10.0106 10.157 9.20997 10.157H4.3709L8.21934 13.0264C8.90069 13.5344 9.18619 14.4625 8.91987 15.3036L7.43457 19.9948L11.4317 17.0145C12.0736 16.536 12.9264 16.536 13.5683 17.0145L17.5654 19.9948L16.0801 15.3036C15.8138 14.4625 16.0993 13.5344 16.7807 13.0264L20.6291 10.157H15.79C14.9894 10.157 14.2779 9.61146 14.0212 8.80079Z",
    fill: "#7C7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomDoubleDelux);
export default __webpack_public_path__ + "static/media/room-double-delux.da876304e3a80e8f3747ce0a5f095e2a.svg";
export { ForwardRef as ReactComponent };